/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import constants from '../../constants';
import { dispatch } from '../../store/state/state-manager';
import { getContainerName } from '../../case/common-helper';
import type { Action } from '../../store/state/state-manager';
import { getResolvedTargetName } from '../../router/routing-manager';
import { buildContextName, buildModalContext } from '../../utils/context-utils';
import { setLoading, addContainerItem } from '../../store/state/actions/action-creators';
import { ACTION_GETOBJECTWIDEACTION } from '../../store/state/actions';

import { executeOpenObjectActionRequest } from './helper';

const processOpenObjectActionRequest = (actionInPayload: Action['payload']) => {
  actionInPayload.openActionType = ACTION_GETOBJECTWIDEACTION;
  const containerName = getContainerName(actionInPayload.openActionType, actionInPayload);
  if (containerName === constants.MODAL) {
    const modalContainerName = getContainerName(actionInPayload.openActionType, actionInPayload);
    const modalTarget = getResolvedTargetName(modalContainerName, actionInPayload.context);
    const modalContext = buildModalContext(
      actionInPayload.context,
      buildContextName(modalContainerName, actionInPayload.context)
    );

    // Adds modal container in a loading state while the request for data is being resolved
    dispatch(
      addContainerItem({
        target: modalTarget,
        context: modalContext,
        containerItemID: modalContext,
        key: actionInPayload.caseID,
        caseViewMode: constants.PERFORM_MODE,
        actionName: actionInPayload.name,
        showProgress: true,
        root: {
          type: 'reference',
          config: {
            context: constants.getProperty(constants.CASE_INFO.CASE_INFO_CONTENT),
            type: 'view'
          }
        },
        data: {
          key: actionInPayload.caseID,
          objectInfo: {
            ID: actionInPayload.caseID
          }
        }
      })
    );
    dispatch(setLoading({ context: modalContext }));
    actionInPayload.modalLoadingContainer = { target: modalTarget, context: modalContext };

    executeOpenObjectActionRequest(actionInPayload);
  }
  return executeOpenObjectActionRequest(actionInPayload);
};

export default processOpenObjectActionRequest;
